import React, { Component } from 'react'
import { Select } from 'antd'
import { compose } from 'recompose'
import withSelectFetch from '../withSelectFetch'
import withSpinning from '../../HOC/withSpinning'
import withSort from '../../HOC/withSort'

const Option = Select.Option

class Status extends Component {
  render() {
    const { value, onChange, placeholder, data } = this.props
    return (
      <Select
        style={{ minWidth: '130px' }}
        value={value}
        showSearch
        onChange={onChange}
        placeholder={placeholder || 'Select a Status'}
        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
        {data.map((c) => (
          <Option value={c}>{c}</Option>
        ))}
      </Select>
    )
  }
}

const StatusSelect = compose(
  withSelectFetch({ dropdown: 'client', name: 'status', forceFetch: true }),
  withSpinning,
  withSort
)(Status)

export default StatusSelect
